import script from "./Body.vue?vue&type=script&setup=true&lang=js"
export * from "./Body.vue?vue&type=script&setup=true&lang=js"

import "./Body.vue?vue&type=style&index=0&id=2bf157e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf157e0"]])

export default __exports__